var React = require('react');

function SeelayArtInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Seelay Art"),React.createElement("g",{"key":1},React.createElement("g",{"id":"logo"},[React.createElement("path",{"fill":"#000000","className":"logo__rect","id":"Rectangle","d":"M42,50H8c-4.4,0-8-3.6-8-8V8c0-4.4,3.6-8,8-8h34c4.4,0,8,3.6,8,8v34C50,46.4,46.4,50,42,50z","key":0}),React.createElement("path",{"stroke":"null","fill":"#fcfcfc","id":"A","d":"m27.79104,32.16864l-5.33398,-21.44358l7.13264,0l8.12501,28.54988l-25.42942,0l4.83779,-18.32678l7.44276,0l-2.54294,11.22048l5.76814,0l0,-0.00001l0,0.00001z","className":"logo__path","key":1})]))]);
}

SeelayArtInline.defaultProps = {"width":"50","height":"50"};

module.exports = SeelayArtInline;

SeelayArtInline.default = SeelayArtInline;
